// extracted by mini-css-extract-plugin
export var centerText = "_6j-8";
export var container = "_6j-0";
export var doughnutContainer = "_6j-7";
export var legend = "_6j-a";
export var legendItemColorDisplay = "_6j-b";
export var legendItemLabel = "_6j-d";
export var legendItemValue = "_6j-c";
export var lg = "_6j-5";
export var maxWidth = "_6j-9";
export var md = "_6j-4";
export var responsive = "_6j-6";
export var sm = "_6j-3";
export var xs = "_6j-2";
export var xxs = "_6j-1";